import React from 'react'

import classes from './styles'

class Answer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isTransitionEnable: false,
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const isUserAnswerd = () => {
      return this.props.currentAnswer === null
        && nextProps.currentAnswer !== null
    }

    this.setState({
      isTransitionEnable: isUserAnswerd()
    })
  }


  render() {
    const { answer, toAnswer, currentAnswer } = this.props

    const hideClass = currentAnswer && currentAnswer.id !== answer.id
      ? classes.notSelected : ''

    const selectedClass = currentAnswer && currentAnswer.id === answer.id
      ? classes.selected : ''

    const transitionClass = this.state.isTransitionEnable
      ? classes.transition : ''

    const onClick = currentAnswer === null ? toAnswer.bind(null, answer) : () => {}

    return (
      <div
        className={[classes.answer, hideClass, selectedClass, transitionClass].join(' ')}
        onClick={onClick}
      >
        <div className={[classes.circle, 'circle'].join(' ')} />
        <div>
          {answer.text}
        </div>
      </div>
    )
  }
}

Answer.propTypes = {}

export default Answer


// WEBPACK FOOTER //
// ./src/components/Question/components/Answer/Answer.jsx